import styled from '@emotion/styled/macro';
import { Heading02, Colors } from '@robinpowered/design-system';

export const SectionTitle = styled(Heading02)`
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 2px solid ${Colors.Tan10};
`;
